import axios from 'axios'
import { endpoints } from './endpoints';
import { getReferrer } from '../context/auth';

const authEndpoints = endpoints.auth;

export function signIn(params: any) {
  params['origin'] = process.env.REACT_APP_ORIGIN
  params['referrer'] = getReferrer()
  return axios.post(authEndpoints.signIn(), params)
}

export function getStatus(email: string){
  return axios.post(authEndpoints.getStatus(), {email})
}

export function sendVerificationCode(purpose: string, email: string, languageCode: string) {
  return axios.post(authEndpoints.sendVerificationCode(), {purpose, email, language_code: languageCode, origin: process.env.REACT_APP_ORIGIN})
}

export function verifyVerificationCode(email: string, secret: string, verification_code: string) {
  return axios.post(authEndpoints.verifyVerificationCode(), {email, secret, verification_code, origin: process.env.REACT_APP_ORIGIN})
}

export function setPassword(accessToken: string, password: string) {
  return axios.post(authEndpoints.setPassword(), {access_token: accessToken, password})
}

export function signOut() {
  return axios.get(authEndpoints.signOut())
}

export function getGuestSession() {
  return axios.get(authEndpoints.getGuestSession())
}